<template>
  <div class="dashboard-editor-container">
    <!-- <el-row
      type="flex"
      justify="space-between"
      style="background:#fff; padding:16px 0 0 0; margin-bottom:32px;"
    >
    <el-col :span="4" style="padding: 0;">
        <CoreCard :cardInfo="cardDataOne" />
      
      </el-col>
      <el-col :span="4" v-for="(item,index) in cardData" :key="index" style="padding: 0;">
        <CoreCard :cardInfo="item"/>
      </el-col>
    </el-row> -->
    <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="24" :lg="24">
        <LineChart
          :chart-data="{
            xAxis: lineChartDataOne.xAxisData,
            series: [
              { name: '生产数量', data: lineChartDataOne.seriesDataOne },
              { name: '发货数量', data: lineChartDataOne.seriesDataTwo }
            ]
          }"
          :chart-info="{ title: '近30天每日产量和发货量趋势' }"
        />
      </el-col>
    </el-row>
        
    
    
  <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="12" :lg="12">
        <BarChart
            :chart-data="barChartData"
            :chart-info="{ title: '当日工厂生产进度统计' }"
          />
      </el-col>
          <el-col :xs="24" :sm="12" :lg="12">
        <BarChart
            :chart-data="barChartData2"
            :chart-info="{ title: '当日工厂发货进度统计' }"
          />
      </el-col>
    </el-row>
  <!--
    <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="24" :lg="24">

      </el-col>
    </el-row>
        <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="24" :lg="24">

      </el-col>
    </el-row>
    <el-row style="background:#fff;padding:16px 16px 0;margin-bottom:32px;">
      <el-col :xs="24" :sm="24" :lg="24">

      </el-col>
    </el-row> -->
  </div>
</template>

<script>
import { scancount,inspectscanmap } from "@/api/report";
import { workCountCurDay,workPlanCountCurDay,outCountCurDay,outPlanCountCurDay,scanCountCurYear,scanCountALL,scanCountCurDay,scanWarningCountCurDay,
  scanWarningCountCurYear,workAndOutCount30Day,scanConsumer30DayByArea,scanConsumerCurYearByArea,scanConsumer30DayByDate,scanConsumer30DayByProduct,
  warningScanConsumerCurYearByArea,warningScanConsumer30DayByDate,warningScanConsumer30DayByProduct,
  scanInspect30DayByArea,scanInspectCurYearByArea,scanInspect30DayByDate,scanInspect30DayByProduct,factoryWorkOutCountCurDay } from "@/api/board";
import CoreCard  from"../components/CoreCard.vue";
import LineChart  from"../components/LineChart.vue";
import CustomeListCard from "../components/CustomeListCard.vue";
import ShandongMap from '../components/ShandongMap.vue';
import ChinaMap from '../components/ChinaMap.vue';
import BarChart from '../components/BarChart.vue';
export default {
  name: "DashboardOverview",
  components: {
    CoreCard,
    LineChart,
    ShandongMap,
    ChinaMap,
    CustomeListCard,
    BarChart
  },
  data() {
    return {
      cardDataOne:{ // 卡片1默认数据
            titleOne:"今日产量",
            numOne:0,
            titleTwo:"今日计划产量",
            numTwo:0,
            ratioLabel:"完成率"
      },
      cardData:[
          {
            titleOne:"今日发货量",
            numOne:0,
            titleTwo:"今日计划发货量",
            numTwo:0,
            // ratioLabel:"完成率"
          },
          // {
          //   titleOne:"年度累计扫码量",
          //   numOne:0,
          //   titleTwo:"历史累计扫码次数",
          //   numTwo:0,
          //   // ratioLabel:"完成率"
          // },
          // {
          //   titleOne:"今日用户扫码量",
          //   numOne:0,
          //   marginTop:'0%'
          // },
          // {
          //   titleOne:"今日用户预警数",
          //   numOne:0,
          //   marginTop:'0%'
          // },
          // {
          //   titleOne:"年度累计用户预警数",
          //   numOne:0,
          //   marginTop:'0%'
          // },
      ],
      lineChartInfo:{
        title:"折线图1"
      },
      scanData: [],
      scanData1: [],
      scanInspect: [],
      allCities: [        
        '北京市',
        '天津市',
        '河北省',
        '山西省',
        '内蒙古自治区',
        '辽宁省',
        '吉林省',
        '黑龙江省',
        '上海市',
        '江苏省',
        '浙江省',
        '安徽省',
        '福建省',
        '江西省',
        '山东省',
        '河南省',
        '湖北省',
        '湖南省',
        '广东省',
        '广西壮族自治区',
        '海南省',
        '重庆市',
        '四川省',
        '贵州省',
        '云南省',
        '西藏自治区',
        '陕西省',
        '甘肃省',
        '青海省',
        '宁夏回族自治区',
        '新疆维吾尔自治区',
        '台湾省',
        '香港特别行政区',
        '澳门特别行政区'
      ],
      customPieces: [
        { gt: 100, label: '> 100 次', color: '#3c82e1' },
        { gte: 50, lte: 100, label: '50 - 100次', color: '#27e1e6' },
        { gte: 20, lt: 50, label: '10 - 50 次', color: '#e1783c' },
        { gt: 0, lt: 20, label: '1 - 10 次', color: '#e6e622' },
        { value: 0, label: '无扫码', color: '#3ce15a' }
      ],
      barChartKey: 0, // BarChart 组件刷新标记（初始值 0）
      barChartData: {
        xAxis: ["工厂一", "工厂二", "工厂三", "工厂四", "工厂五", "工厂六"],
        series: [
          { name: "计划产量", data: [0, 0, 0, 0, 0, 0] },
          { name: "实际产量", data: [0, 0, 0, 0, 0, 0]},

        ]
      },
      barChartData2: {
        xAxis: ["工厂一", "工厂二", "工厂三", "工厂四", "工厂五", "工厂六"],
        series: [
          { name: "计划发货量", data: [0, 0, 0, 0, 0, 0] },
          { name: "实际发货量", data: [0, 0, 0, 0, 0, 0]},

        ]
      },
      lineChartDataOne:{},//近30天每日产量和发货量趋势
      shandongMapOne:{},//用户扫码分布热力图
      cardList1: [], //用户30天扫码数量统计
      cardList11: [],//用户30天异地扫码数量统计
      cardList2: [], //用户30天扫码产品统计
      cardList22: [],//用户30天异地扫码产品统计
      cardList3: [], //30天窜货预警数量统计
      cardList4: [], //30天窜货预警产品统计
    };
  },
  computed: {
    // fullScanData() {
    //   console.log('allCities:', this.allCities);        // 看看是否为空
    //   console.log('scanData:', this.scanData);          // 看看是否有数据
    //   const result = this.allCities.map(name => {
    //     const item = this.scanData.find(d => d.name === name);
    //     return {
    //       name,
    //       value: item ? item.value : 0
    //     };
    //   });
    //   console.log('fullScanData:', result); // 看看结果
    //   return result;
    // },
    // fullScanData1() {
    //   const result = this.allCities.map(name => {
    //     const item = this.scanData1.find(d => d.name === name);
    //     return {
    //       name,
    //       value: item ? item.value : 0
    //     };
    //   });
    //   console.log('fullScanData1:', result); // 看看结果
    //   return result;
    // },
    // fullScanData2() {
    //   console.log('allCities:', this.allCities);        // 看看是否为空
    //   console.log('scanInspect:', this.scanInspect);          // 看看是否有数据
    //   const result = this.allCities.map(name => {
    //     const item = this.scanInspect.find(d => d.name === name);
    //     return {
    //       name,
    //       value: item ? item.value : 0
    //     };
    //   });
    //   console.log('fullScanData2:', result); // 看看结果
    //   return result;
    // }
  },

  mounted() {
    // this.getWorkCountCurDay();
    // this.getWorkPlanCountCurDay();
    // this.getOutCountCurDay();
    // this.getOutPlanCountCurDay();
    // this.getScanCountCurYear();
    // this.getScanCountALL();
    // this.getScanCountCurDay();
    // this.getScanWarningCountCurDay();
    // this.getScanWarningCountCurYear();
    // this.getScanConsumer30DayByDate();
    // this.getScanConsumer30DayByProduct();
    // this.getScanInspect30DayByArea();
    // this.getScanInspect30DayByDate();
    // this.getScanInspect30DayByProduct();
    this.getFactoryWorkOutCountCurDay();
    this.getLineChartDataOne();
    this.getShandongMapOne();

  },
  methods: {

    //获取今日产量
    getWorkCountCurDay(){
     workCountCurDay().then(response => {
        if(response && response.status_code == 200 && response.data!=null){
          this.cardDataOne = { ...this.cardDataOne, numOne: response.data };
          console.log('获取今日产量.data',response.data)
        }
      });
    },
        //获取今日计划产量
    getWorkPlanCountCurDay(){
     workPlanCountCurDay().then(response => {
        if(response && response.status_code == 200 && response.data!=null){
          this.cardDataOne = { ...this.cardDataOne, numTwo: response.data };
          console.log('获取今日计划产量.data',response.data)
        }
      });
    },

    //今日发货量
    getOutCountCurDay(){
     outCountCurDay().then(response => {
        if(response && response.status_code == 200 && response.data!=null){
          this.cardData[0].numOne = response.data;
          console.log('今日发货量.data',response.data)
        }
      });
    },
    //今日计划发货量
    getOutPlanCountCurDay(){
     outPlanCountCurDay().then(response => {
        if(response && response.status_code == 200 && response.data!=null){
          this.cardData[0].numTwo = response.data;
          console.log('今日计划发货量.data',response.data)
        }
      });
    },

    //年度累计扫码量
    getScanCountCurYear(){
     scanCountCurYear().then(response => {
        if(response && response.status_code == 200 && response.data!=null){
          this.cardData[1].numOne = response.data;
          console.log('年度累计扫码量.data',response.data)
        }
      });
    },
    //历史累计扫码次数
    getScanCountALL(){
     scanCountALL().then(response => {
        if(response && response.status_code == 200 && response.data!=null){
          this.cardData[1].numTwo = response.data;
          console.log('历史累计扫码次数.data',response.data)
        }
      });
    },
    //今日扫码量
    getScanCountCurDay(){
     scanCountCurDay().then(response => {
        if(response && response.status_code == 200 && response.data!=null){
          this.cardData[2].numOne = response.data;
          console.log('今日扫码量.data',response.data)
        }
      });
    },
    //今日窜货预警数
    getScanWarningCountCurDay(){
     scanWarningCountCurDay().then(response => {
        if(response && response.status_code == 200 && response.data!=null){
          this.cardData[3].numOne = response.data;
          console.log('今日窜货预警数.data',response.data)
        }
      });
    },
    //年度累计窜货预警数
    getScanWarningCountCurYear(){
     scanWarningCountCurYear().then(response => {
        if(response && response.status_code == 200 && response.data!=null){
          this.cardData[4].numOne = response.data;
          console.log('年度累计窜货预警数.data',response.data)
        }
      });
    },

    //近30天每日产量和发货量趋势
    getLineChartDataOne() {
      workAndOutCount30Day({}).then(response => {

        if(response && response.status_code == 200 && response.data){
          let chartData = {};
          chartData.xAxisData = [];
          chartData.seriesDataOne = []; 
          chartData.seriesDataTwo = []
          for (let i = 0; i < response.data.length; i++) {
            chartData.seriesDataOne.push(response.data[i].workCount);
            chartData.seriesDataTwo.push(response.data[i].outCount);
            response.data[i].createDate = response.data[i].createDate.substring(0,response.data[i].createDate.length - 8);
            chartData.xAxisData.push(response.data[i].createDate);
          }
          this.lineChartDataOne = chartData;
        }
        console.log("折线图数据",this.lineChartDataOne);
      });
    },
      // 用户扫码分布热力图
    getShandongMapOne() {
      const currentYear = new Date().getFullYear(); // 获取当前年份

      //当前年用户扫码分布
      scanConsumerCurYearByArea().then(response => {
          if(response && response.status_code == 200 && response.data){
            let chartData = {}
            chartData.mapdata = [];
            for (let i = 0; i < response.data.length; i++) {
              const obj = {
                name: response.data[i].provinceCodeScan,
                value: response.data[i].qty
              };
              chartData.mapdata.push(obj);
            }
            this.scanData = chartData.mapdata;
            console.log("用户扫码分布热力图",this.scanData );
         }
      });
      // //30天扫码数量统计
      // scanConsumer30DayByDate().then(response => {
      //     if(response && response.status_code == 200 && response.data){
      //       for (let i = 0; i < response.data.length; i++) {
      //         var str = response.data[i].createDateStr + " 【" + response.data[i].count + "】";
      //         this.cardList1.push(str);
      //       }
      //    }
      // });
      // //30天扫码产品统计
      // scanConsumer30DayByProduct().then(response => {
      //     if(response && response.status_code == 200 && response.data){
      //       for (let i = 0; i < response.data.length; i++) {
      //         var str = response.data[i].provinceCodeScan + " 【" + response.data[i].qty + "】 " + response.data[i].cityCodeScan;
      //         this.cardList2.push(str);
      //       }
      //    }
      // });
      //当前年用户异地扫码分布
      // warningScanConsumerCurYearByArea().then(response => {
      //     if(response && response.status_code == 200 && response.data){
      //       let chartData = {}
      //       chartData.mapdata = [];
      //       for (let i = 0; i < response.data.length; i++) {
      //         const obj = {
      //           name: response.data[i].provinceCodeScan,
      //           value: response.data[i].qty
      //         };
      //         chartData.mapdata.push(obj);
      //       }
      //       this.scanData1 = chartData.mapdata;
      //       console.log("用户异地扫码分布热力图",this.scanData1 );
      //    }
      // });
      // //30天异地扫码数量统计
      // warningScanConsumer30DayByDate().then(response => {
      //     if(response && response.status_code == 200 && response.data){
      //       for (let i = 0; i < response.data.length; i++) {
      //         var str = response.data[i].createDateStr + " 【" + response.data[i].count + "】";
      //         this.cardList11.push(str);
      //       }
      //    }
      // });
      // //30天异地扫码产品统计
      // warningScanConsumer30DayByProduct().then(response => {
      //     if(response && response.status_code == 200 && response.data){
      //       for (let i = 0; i < response.data.length; i++) {
      //         var str = response.data[i].provinceCodeScan + " 【" + response.data[i].qty + "】 " + response.data[i].cityCodeScan;
      //         this.cardList22.push(str);
      //       }
      //    }
      // });
      
      // 当前年窜货预警分布
      scanInspectCurYearByArea().then(response => {
          if(response && response.status_code == 200 && response.data){
            let chartData = {}
            chartData.mapdata = [];
            for (let i = 0; i < response.data.length; i++) {
              const obj = {
                name: response.data[i].provinceCodeScan,
                value: response.data[i].qty
              };
              chartData.mapdata.push(obj);
            }
            this.scanInspect = chartData.mapdata;
            console.log("窜货预警热力图",this.scanInspect );
         }
      });
      
      // //30天窜货预警数量统计
      // scanInspect30DayByDate().then(response => {
      //     if(response && response.status_code == 200 && response.data){
      //       for (let i = 0; i < response.data.length; i++) {
      //         var str = response.data[i].createDateStr + " 【" + response.data[i].count + "】";
      //         this.cardList3.push(str);
      //       }
      //    }
      // });
    
      // //30天扫码产品统计
      // scanInspect30DayByProduct().then(response => {
      //     if(response && response.status_code == 200 && response.data){
      //       for (let i = 0; i < response.data.length; i++) {
      //         var str = response.data[i].provinceCodeScan + " 【" + response.data[i].qty + "】 " + response.data[i].cityCodeScan;
      //         this.cardList4.push(str);
      //       }
      //    }
      // });
    },

    //当日工厂生产、发货进度
    getFactoryWorkOutCountCurDay(){
     factoryWorkOutCountCurDay().then(response => {
        if(response && response.status_code == 200 && response.data!=null) {
          const factories = []; // x轴工厂名称
          const workPlanData = []; // 生产计划数据
          const workActualData = []; // 实际生产数据
          const outPlanData = []; // 发货计划数据
          const outActualData = []; // 实际发货数据
                
          response.data.forEach(item => {
            factories.push(item.factory); // 工厂名称
            workPlanData.push(item.workPlanCountCurDay || 0); // 计划产量（兜底0）
            workActualData.push(item.workCountCurDay || 0); // 实际产量
            outPlanData.push(item.outPlanCountCurDay || 0); // 计划发货量
            outActualData.push(item.outCountCurDay || 0); // 实际发货量
          });
      
          // 2. 响应式更新 barChartData 和 barChartData2（整体替换数组，Vue 能检测到变化）
          this.barChartData = {
            ...this.barChartData, // 保留原有其他配置（如样式）
            xAxis: factories, // 替换 x轴数组
            series: [
              { ...this.barChartData.series[0], data: workPlanData }, // 替换计划产量数据
              { ...this.barChartData.series[1], data: workActualData } // 替换实际产量数据
            ]
          };
          
          this.barChartData2 = {
            ...this.barChartData2,
            xAxis: factories,
            series: [
              { ...this.barChartData2.series[0], data: outPlanData },
              { ...this.barChartData2.series[1], data: outActualData }
            ]
          };
      
          // 3. 关键：更新 key，强制 BarChart 组件重新渲染（数据变化立即刷新）
          this.barChartKey += 1;
        
          console.log("折线图数据",response.data);
        }
      });
    },
    
  },
};
</script>

<style lang="scss" scoped>
.dashboard-editor-container {
  padding: 32px;
  background-color: rgb(240, 242, 245);
  position: relative;

  .github-corner {
    position: absolute;
    top: 0px;
    border: 0;
    right: 0;
  }
  .chart-wrapper {
    background: #fff;
    padding: 16px 16px 0;
    margin-bottom: 32px;
  }
}
</style>
